module.exports = __webpack_public_path__ + "img/progateHTML.9a6470e4.webp";